export enum GuidedTourStep {
  AddParty = 'AddParty',
  AddEditParty = 'AddEditParty',
  Notify = 'Notify',
  Sort = 'Sort',
  Search = 'Search',
  Actions = 'Actions',
  Reservations = 'Reservations',
  Recent = 'Recent',
  Analytics = 'Analytics',
  Settings = 'Settings',
  Final = 'Final'
}

export type GuidedTourStepStrings = keyof typeof GuidedTourStep;
